/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

export const GET_REPORTED_TICKETS_REQUEST = "GET_REPORTED_TICKETS_REQUEST";
export const GET_REPORTED_TICKETS_SUCCESS = "GET_REPORTED_TICKETS_SUCCESS";
export const GET_REPORTED_TICKETS_FAILURE = "GET_REPORTED_TICKETS_FAILURE";

export const CREATE_REPORT_TICKET_REQUEST = "CREATE_REPORT_TICKET_REQUEST";
export const CREATE_REPORT_TICKET_SUCCESS = "CREATE_REPORT_TICKET_SUCCESS";
export const CREATE_REPORT_TICKET_FAILURE = "CREATE_REPORT_TICKET_FAILURE";

export const ADD_ATTACHMENTS_REQUEST = "ADD_ATTACHMENTS_REQUEST";
export const ADD_ATTACHMENTS_SUCCESS = "ADD_ATTACHMENTS_SUCCESS";
export const ADD_ATTACHMENTS_FAILURE = "ADD_ATTACHMENTS_FAILURE";

export const TICKET_HOMEPAGE_REQUEST = "TICKET_HOMEPAGE_REQUEST";
export const TICKET_HOMEPAGE_SUCCESS = "TICKET_HOMEPAGE_SUCCESS";
export const TICKET_HOMEPAGE_FAILURE = "TICKET_HOMEPAGE_FAILURE";

export const GET_REQUESTTYPES_REQUEST = "GET_REQUESTTYPES_REQUEST";
export const GET_REQUESTTYPES_SUCCESS = "GET_REQUESTTYPES_SUCCESS";
export const GET_REQUESTTYPES_FAILURE = "GET_REQUESTTYPES_FAILURE";

export const GET_TICKET_STATUS_REQUEST = "GET_TICKET_STATUS_REQUEST";
export const GET_TICKET_STATUS_SUCCESS = "GET_TICKET_STATUS_SUCCESS";
export const GET_TICKET_STATUS_FAILURE = "GET_TICKET_STATUS_FAILURE";

export const GET_TICKET_COMMENTS_REQUEST = "GET_TICKET_COMMENTS_REQUEST";
export const GET_TICKET_COMMENTS_SUCCESS = "GET_TICKET_COMMENTS_SUCCESS";
export const GET_TICKET_COMMENTS_FAILURE = "GET_TICKET_COMMENTS_FAILURE";

export const ADD_TICKET_COMMENTS_REQUEST = "ADD_TICKET_COMMENTS_REQUEST";
export const ADD_TICKET_COMMENTS_SUCCESS = "ADD_TICKET_COMMENTS_SUCCESS";
export const ADD_TICKET_COMMENTS_FAILURE = "ADD_TICKET_COMMENTS_FAILURE";

export const RE_OPEN_TICKET_REQUEST = "RE_OPEN_TICKET_REQUEST";
export const RE_OPEN_TICKET_SUCCESS = "RE_OPEN_TICKET_SUCCESS";
export const RE_OPEN_TICKET_FAILURE = "RE_OPEN_TICKET_FAILURE";

export const GET_COMPLETED_TICKETS_REQUEST = "GET_COMPLETED_TICKETS_REQUEST";
export const GET_COMPLETED_TICKETS_SUCCESS = "GET_COMPLETED_TICKETS_SUCCESS";
export const GET_COMPLETED_TICKETS_FAILURE = "GET_COMPLETED_TICKETS_FAILURE";

export const GET_TICKETS_COUNTS_REQUEST = "GET_TICKETS_COUNTS_REQUEST";
export const GET_TICKETS_COUNTS_SUCCESS = "GET_TICKETS_COUNTS_SUCCESS";
export const GET_TICKETS_COUNTS_FAILURE = "GET_TICKETS_COUNTS_FAILURE";


export const GET_TICKETS_COUNTS_FOR_ACTIVE_REQUEST = "GET_TICKETS_COUNTS_FOR_ACTIVE_REQUEST";
export const GET_TICKETS_COUNTS_FOR_ACTIVE_SUCCESS = "GET_TICKETS_COUNTS_FOR_ACTIVE_SUCCESS";
export const GET_TICKETS_COUNTS_FOR_ACTIVE_FAILURE = "GET_TICKETS_COUNTS_FOR_ACTIVE_FAILURE";

export const GET_TICKET_DETAILS_REQUEST = "GET_TICKET_DETAILS_REQUEST";
export const GET_TICKET_DETAILS_SUCCESS = "GET_TICKET_DETAILS_SUCCESS";
export const GET_TICKET_DETAILS_FAILURE = "GET_TICKET_DETAILS_FAILURE";



